module.exports = __webpack_public_path__ + "img/logisztika_kep1.0ab34b01.png";